export default "__VITE_ASSET__B0h6sPjq__"